import { Empty, Pagination } from "antd";
import { useEffect, useState } from "react";
import SortingArrow from "../../../../Common/SortingArrow";
import toast from "react-hot-toast";
import globalRequest from "../../../../utils/global/globalRequest";
import * as Apis from "../../../../utils/helper/enum";
import { useDispatch } from "react-redux";
import { changeLoader } from "../../../../redux/reducers/loader";
import AllOrders from "../../../../Modal/AllOrders";
import { paginationLimit, paginationPages } from "../../../../utils/helper/constants";

const DiscountCouponReports = ({ inputData, setInputData }) => {
  const dispatch = useDispatch();

  const [list, setList] = useState([]);
  const [listOfOrders, setListOfOrders] = useState([]);
  const [paginationModel, setPaginationModel] = useState(paginationLimit);
  // const [inputData, setInputData] = useState({});
  const [totalRows, setTotalRows] = useState(0); //totalRows
  const [isAllOrdersModalOpen, setIsAllOrdersModalOpen] = useState(false);

  const getAllReports = async () => {
    dispatch(changeLoader(true));
    try {
      let params = {
        ...inputData,
        page: paginationModel?.page,
        limit: paginationModel?.limit,
        orderType: "ASC",
      };
      let response = await globalRequest(Apis.MANAGE_REPORT.GET_ALL_COUPON_REPORT, "get", {}, { params: params }, true);
      let apiResponse = response?.data;
      if (response?.status === 200) {
        setList(apiResponse?.data?.data?.data);
        setTotalRows(apiResponse?.data?.data?.paginator?.itemCount);
      } else {
        // toast.error(apiResponse?.message);
      }
    } catch (e) {
      toast.error(e?.message);
    }
    dispatch(changeLoader(false));
  };

  useEffect(() => {
    getAllReports();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inputData, paginationModel]);

  const handleSort = (column, order) => {
    setInputData((prev) => ({
      ...prev,
      order_by: column,
      order_type: order,
    }));
  };

  const handleAllOrdersCancel = () => {
    setIsAllOrdersModalOpen(false);
  };

  const getAllOrdersOfCoupon = async (id) => {
    dispatch(changeLoader(true));
    try {
      let params = {
        ...inputData,
        page: paginationModel?.page,
        limit: paginationModel?.limit,
      };
      let response = await globalRequest(Apis.MANAGE_REPORT.GET_ALL_ORDERS_OF_COUPON + "/" + id, "get", {}, { params: params }, true);
      let apiResponse = response?.data;
      if (response?.status === 200) {
        setListOfOrders(apiResponse?.data?.data?.data);
        setIsAllOrdersModalOpen(true);
      } else {
        // toast.error(apiResponse?.message);
      }
    } catch (e) {
      toast.error(e?.message);
    }
    dispatch(changeLoader(false));
  };

  return (
    <>
      <div className="relative overflow-x-auto">
        <table className="w-full  text-left	 text-sm  text-gray-500">
          <thead className=" text-gray-700 capitalize text-xs	 bg-gray-50">
            <tr>
              <th scope="col" className="px-3 py-3 whitespace-nowrap">
                  ID{" "}
                  <SortingArrow
                    onSort={(order) => handleSort("id", order)}
                  />
                </th>
                <th scope="col" className="px-3 py-3 whitespace-nowrap">
                S.No <SortingArrow onSort={() => handleSort()} />
              </th>
              <th scope="col" className="px-3 py-3 whitespace-nowrap">
                Coupon Name <SortingArrow onSort={() => handleSort()} />
              </th>
              <th scope="col" className="px-3 py-3 whitespace-nowrap">
                Total Usage Count <SortingArrow onSort={() => handleSort()} />
              </th>
            </tr>
          </thead>
          <tbody>
            {list && list.length > 0 ? (
              list.map((item, index) => {
                return (
                  <tr className="bg-white border-b" key={index}>
                    <td className="px-3 py-4 vertical-top whitespace-nowrap">
                      {item?.id || "-"}
                    </td>
                    <td className="px-3 py-4 vertical-top whitespace-nowrap">{item?.id}</td>
                    <td className="px-3 py-4 vertical-top whitespace-nowrap">{item?.couponCode}</td>
                    <td className="px-3 py-4 vertical-top">
                      <span
                        className="flex items-center hover:bg-[#176b5320] text-[#176b53] text-center px-[12px] py-[8px] rounded w-fit h-[32px] cursor-pointer"
                        onClick={() => {
                          // setIsAllOrdersModalOpen(true);
                          if (item?.usageCount > 0) getAllOrdersOfCoupon(item?.id);
                        }}
                      >
                        {item?.usageCount}
                      </span>
                    </td>
                  </tr>
                );
              })
            ) : (
              <tr>
                <td colSpan={13} className="text-center mt-3">
                  <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {list?.length ? (
        <div className="text-right mt-4">
          <Pagination
            defaultCurrent={1}
            total={totalRows}
            pageSizeOptions={paginationPages}
            showSizeChanger={true}
            current={paginationModel?.page}
            pageSize={paginationModel?.limit}
            onChange={(page) => setPaginationModel((prev) => ({ ...prev, page: page }))}
            onShowSizeChange={(current, size) => setPaginationModel((prev) => ({ ...prev, limit: size }))}
          />
        </div>
      ) : null}
      <AllOrders isOpen={isAllOrdersModalOpen} onCancel={handleAllOrdersCancel} data={listOfOrders} />
    </>
  );
};
export default DiscountCouponReports;
